// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LhGv","name":"styles_name__20Efw","phone":"styles_phone__2n5S9"};